import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages";
import MakeNFT from "./pages/makeNFT";
import Map from "./pages/map";
import Gallery from "./pages/gallery";
import Explore from "./pages/explore";
import './index.css';
import Navi from './components/nav';

export default function App() {
  
  return (
    <BrowserRouter>
      <div className="App">
      <Navi/>
      <Routes path="/" element={<Home />}>
        <Route index element={<Home />} />
        <Route path="map" element={<Map />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="explore" element={<Explore />} />
        <Route path="makenft" element={<MakeNFT />} />
      </Routes>
      </div>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));